import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {

}

const AGREGAR_CARTERA = 'AGREGAR_CARTERA'

export const agregarHistorialCartera = createAsyncThunk(
    AGREGAR_CARTERA,
    async (data) => {
        try {

            const agregarCartera = host + `Historial/agregarHistorialCartera`
            const res = await axios.post(agregarCartera, { data })
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const historialSlice = createSlice({
    name: 'historialSlice',
    initialState: dataInicial,
    reducers: {
        resetDataHistorial(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [agregarHistorialCartera.fulfilled]: (state, { payload }) => {

        },
    },
})

export const {
    resetDataHistorial
} = historialSlice.actions

export const HistorialAtencionACliente = historialSlice.reducer

